module.exports = {
    calendly_url: process.env.REACT_APP_CALENDLY_URL
}